import React from 'react';
import {TextOutdent} from "@phosphor-icons/react";

const IconCollapseMenu = (props) => (
    <TextOutdent {...props}/>
);

export default IconCollapseMenu;